module.exports = __webpack_public_path__ + "media/assets/images/tour/5_Tour_1-b11664984edc1d2beab548190424a3bb.png";